import React from "react";
import { Home as HomeIcon, CalendarClock, CalendarDays, Lock, FileBarChart2, MoreHorizontal } from "lucide-react";

const TABS = [
  { key: "home", label: "Home", Icon: HomeIcon },
  { key: "timeline", label: "Timeline", Icon: CalendarClock },
  { key: "calendar", label: "Calendar", Icon: CalendarDays },
  { key: "vault", label: "Vault", Icon: Lock },
  { key: "reports", label: "Reports", Icon: FileBarChart2 },
  { key: "more", label: "More", Icon: MoreHorizontal },
];

export default function BottomNav({ view, setView }) {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 border-t"
      style={{ background: "rgba(7,11,20,0.96)", backdropFilter: "blur(12px)", borderColor: "var(--ek-border)", paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="bottom-nav"
    >
      <div className="max-w-2xl mx-auto grid grid-cols-6">
        {TABS.map(({ key, label, Icon }) => {
          const active = view === key;
          return (
            <button
              key={key}
              data-testid={`nav-${key}`}
              onClick={() => setView(key)}
              className="flex flex-col items-center justify-center gap-1 py-2.5 transition-colors"
              style={{ color: active ? "var(--ek-primary)" : "var(--ek-text-muted)" }}
            >
              <Icon className="h-5 w-5" strokeWidth={active ? 2.4 : 1.8} />
              <span className="text-[10px] font-mono-ek tracking-wide uppercase">{label}</span>
              {active && <span className="h-0.5 w-6 rounded-full ek-glow" style={{ background: "var(--ek-primary)" }} />}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
